import { h, Fragment } from 'preact';
import PropTypes from 'prop-types';

import SkyItBox from '../../3-molecules/sky-it-box/sky-it-box';

const renderMessengerPeopleWidget = (id) => (
  <Fragment>
    <a href="https://www.messengerpeople.com/" />
    <script src="https://cdn.messengerpeople.com/widget.cube.js" data-widget="mpWidget" data-id={id} />
  </Fragment>
);

const SkyItMessengerPeople = ({ boxTitle, boxDescription, telegramWidgetId = '', facebookWidgetId = '' }) => {
  return (
    <SkyItBox title={boxTitle} description={boxDescription}>
      <div className="c-messenger-people">
        {telegramWidgetId && (
          <div className="c-messenger-people__item">{renderMessengerPeopleWidget(telegramWidgetId)}</div>
        )}
        {facebookWidgetId && (
          <div className="c-messenger-people__item">{renderMessengerPeopleWidget(facebookWidgetId)}</div>
        )}
      </div>
    </SkyItBox>
  );
};

SkyItMessengerPeople.propTypes = {
  boxTitle: PropTypes.string.isRequired,
  boxDescription: PropTypes.string,
  telegramWidgetId: PropTypes.string,
  facebookWidgetId: PropTypes.string,
};

export default SkyItMessengerPeople;
